import { StyleSheet, Text, TouchableOpacity } from 'react-native'
import { corporateColor, grayBorders, toqueColor, white } from '../../theme/colors'

interface ItemProps {
  isSelected: boolean
  getDaySelected: (day: number) => void
  day: { id: number; name: string }
  translation: (value: string) => string
}
export const DayItem = ({ isSelected, day, getDaySelected, translation }: ItemProps) => (
  <TouchableOpacity
    onPress={() => getDaySelected(day.id)}
    style={[styles.containerItem, isSelected && styles.isSelected]}
    activeOpacity={0.7}
  >
    <Text style={[styles.primarytext, isSelected && styles.isSelectedText]}>{day.id}</Text>
    <Text style={[styles.secondaryText, isSelected && styles.isSelectedText]}>
      {translation(day.name)}
    </Text>
  </TouchableOpacity>
)

const styles = StyleSheet.create({
  containerItem: {
    padding: 14,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: grayBorders,
    marginRight: 8,
    alignItems: 'center',
  },
  primarytext: {
    fontSize: 20,
    fontWeight: 'bold',
    color: corporateColor,
  },
  secondaryText: {
    fontSize: 16,
    color: corporateColor,
  },

  isSelected: {
    backgroundColor: toqueColor,
    borderColor: toqueColor,
  },

  isSelectedText: {
    color: white,
  },
})
